import { FunctionComponent } from 'react';
import { IconAdd, IconSubtract } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconMinus, IconPlusLarge } from '@tock/icons';
import ControlButton from 'components/profile/culinary-travel-log/ControlButton';
import ControlPanel from 'components/profile/culinary-travel-log/ControlPanel';

export interface Props {
  map: google.maps.Map;
}

const ZoomControls: FunctionComponent<Props> = ({ map }) => {
  return (
    <ControlPanel>
      <ControlButton onClick={() => map.setZoom((map.getZoom() ?? 0) + 1)} title="Zoom in">
        <IconMigrationUtil legacyIcon={<IconAdd />} newIcon={<IconPlusLarge />} />
      </ControlButton>
      <ControlButton onClick={() => map.setZoom((map.getZoom() ?? 0) - 1)} title="Zoom out">
        <IconMigrationUtil legacyIcon={<IconSubtract />} newIcon={<IconMinus />} />
      </ControlButton>
    </ControlPanel>
  );
};

export default ZoomControls;
